import { render, staticRenderFns } from "./downdetail.vue?vue&type=template&id=648a4556&scoped=true"
import script from "./downdetail.vue?vue&type=script&lang=js"
export * from "./downdetail.vue?vue&type=script&lang=js"
import style0 from "./downdetail.vue?vue&type=style&index=0&id=648a4556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648a4556",
  null
  
)

export default component.exports